define(function (require) {


    // Holds a list of all modules to use when parsing
    var modules = [];

    // Go through all modules and runs their parse functions, adding up the result into one parsed string
    function parse(originalContent, next) {
        if (next && typeof next == "function") {
            run(modules.concat([]), originalContent, next);
        }
    }

    // Go through a list of parser, wait for each to finish before going to the next
    function run(moduleList, content, next) {
        var parser = moduleList.shift();
        if (parser) {
            parser.parse(content, function (parsedContent) {
                run(moduleList, parsedContent, next);
            });
        }
        else {
            next(content);
        }
    }

    // Define which modules we will use
    function setModules(list) {
        if (list.constructor == Array) {
            modules = list;
        }
        else {
            modules = [];
            for (var i = 0, ii = arguments.length; i < ii; i++) {
                modules.push(arguments[i]);
            }
        }
    }

    // Gets a list of current modules
    function getModules() {
        return modules;
    }


    return {
        setModules: setModules,
        getModules: getModules,
        parse: parse
    };

});


// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/parser.js